import * as types from "./actionTypes"

export const changeMap = (value: object) => ({
  type: types.CHANGE_MAP,
  value
})
